import { People } from '~/services/Http';

const FALLBACK_LANG_CODE = 'en';
export const getCurrentTranslation = (
  translations: People.QuickLinkTranslationDto[],
): People.QuickLinkTranslationDto => {
  const language = localStorage.getItem('i18nextLng');

  if (language) {
    const translation = translations.find((t) => t.language === language);

    if (translation) {
      return translation;
    }
  }

  const fallbackTranslation = translations.find(
    (t) => t.language === FALLBACK_LANG_CODE,
  );

  return fallbackTranslation || translations[0];
};
